export default {
  Adjustment: "adjustment",
  Margin: "margin",
  Retouch: "retouch",
  Websize: "websizes",
};
